/* Celebra — lecture des vidéos dans la fenêtre d'aperçu produit.
 *
 * Le thème construit cette fenêtre en clonant le HTML de la fiche produit.
 * Or un <video autoplay> cloné puis réinséré ne redéclenche pas sa lecture
 * automatique : on obtenait des images figées. On la relance donc à la main.
 *
 * On surveille l'ouverture du dialogue lui-même plutôt qu'un bouton précis :
 * peu importe d'où l'aperçu est ouvert, le comportement est le même.
 */
(function () {
  var minuteur = null;

  function lancer(racine) {
    var videos = racine.querySelectorAll('video');
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      if (!v.paused) continue;
      // on ignore ce qui n'est pas à l'écran (diapositives non actives)
      var r = v.getBoundingClientRect();
      if (r.width < 2 || r.height < 2) continue;

      v.muted = true;
      v.playsInline = true;
      if (v.readyState === 0) {
        try { v.load(); } catch (e) {}
      }
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }

  function planifier(dialogue) {
    clearTimeout(minuteur);
    minuteur = setTimeout(function () {
      var boite = dialogue.querySelector('dialog');
      if (boite && boite.open) lancer(dialogue);
    }, 200);
  }

  function brancher(dialogue) {
    if (dialogue.__celebraVideo) return;
    dialogue.__celebraVideo = true;
    // ouverture, contenu injecté, changement de diapositive
    new MutationObserver(function () { planifier(dialogue); })
      .observe(dialogue, { attributes: true, childList: true, subtree: true });
    planifier(dialogue);
  }

  function chercher() {
    var dialogue = document.getElementById('quick-add-dialog');
    if (dialogue) brancher(dialogue);
    return !!dialogue;
  }

  function demarrer() {
    if (chercher()) return;
    // le dialogue est injecté plus tard : on attend son apparition
    var observateur = new MutationObserver(function () {
      if (chercher()) observateur.disconnect();
    });
    observateur.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
